import { useState } from 'react'
import { changeLocale, readStoredLocale, type SupportedLocale } from '../i18n'

const LOCALES = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
  { code: 'el', label: 'EL' },
] as const

type Locale = SupportedLocale

export function LanguageSwitcher() {
  // Seed from the SAME source i18n/index.ts already used to pick i18next's
  // initial `lng` — the radio must show what's actually rendering from the
  // very first paint, not flip a beat later once a mount effect corrects it.
  const [locale, setLocale] = useState<Locale>(readStoredLocale)

  const onChange = (next: Locale) => {
    setLocale(next)
    changeLocale(next)
  }

  return (
    <div
      role="radiogroup"
      aria-label="Interface language"
      className="flex items-center rounded-md border border-stone-300 text-xs dark:border-stone-700"
    >
      {LOCALES.map(l => (
        <button
          key={l.code}
          type="button"
          role="radio"
          aria-checked={locale === l.code}
          onClick={() => onChange(l.code)}
          className={[
            'px-2 py-1 transition',
            locale === l.code
              ? 'bg-stone-900 text-white dark:bg-stone-100 dark:text-stone-900'
              : 'text-stone-600 hover:bg-stone-100 dark:text-stone-400 dark:hover:bg-stone-800',
          ].join(' ')}
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}
